export const enum VoucherBannerVariant {
  Copy = 'copy',
  Button = 'button',
}
